<template>
  <div id="users_detail">
    <Navbar
      current="Detalhe do Usuário"
      :link="$paths.users.list"
      :linkName="'Usuários'"
    />
    <Sidebar />
    <Container>
      <Header title="Detalhe do Usuário">
        <template v-slot:button v-if="!loadingItems">
          <button
            class="btn btn-del me-2"
            @click="handleBlock"
            v-if="item.active"
          >
            <i class="fa-solid fa-ban"></i>
            Bloquear
          </button>
          <button
            class="btn btn-outline-success me-2"
            @click="handleBlock"
            v-else
          >
            <i class="fa-solid fa-unlock-keyhole"></i>
            Desbloquear
          </button>

          <button
            class="btn btn-outline-primary"
            @click="handlePremium"
            v-if="!item.isPremium"
          >
            <i class="fa-solid fa-crown"></i>
            Tornar Premium
          </button>
          <button
            class="btn btn-outline-danger"
            @click="handlePremium"
            v-if="item.isPremium && item.subscriptionConfig.isCancelable"
          >
            <i class="fa-solid fa-crown"></i>
            Remover Premium
          </button>
        </template>
      </Header>
      <LoadingContainer v-if="loadingItems" />
      <template v-else>
        <ul class="nav nav-tabs mb-3">
          <li class="nav-item">
            <a
              class="nav-link"
              :class="{ active: activeTab === 'cadastro' }"
              href="#"
              @click.prevent="activeTab = 'cadastro'"
              >Informações de cadastro</a
            >
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              :class="{ active: activeTab === 'assinatura' }"
              href="#"
              @click.prevent="activeTab = 'assinatura'"
              >Assinatura</a
            >
          </li>
          <li class="nav-item" v-if="item.type == 'professional'">
            <a
              class="nav-link"
              :class="{ active: activeTab === 'profissional' }"
              href="#"
              @click.prevent="activeTab = 'profissional'"
              >Informações profissionais</a
            >
          </li>
          <li class="nav-item" v-if="item.type == 'professional'">
            <a
              class="nav-link"
              :class="{ active: activeTab === 'prontuario' }"
              href="#"
              @click.prevent="activeTab = 'prontuario'"
              >Prontuário</a
            >
          </li>
          <li class="nav-item" v-if="item.type == 'professional'">
            <a
              class="nav-link"
              :class="{ active: activeTab === 'receitas' }"
              href="#"
              @click.prevent="activeTab = 'receitas'"
              >Receitas</a
            >
          </li>
        </ul>

        <div v-show="activeTab === 'cadastro'">
          <UserInfo :user="item" />
        </div>

        <div v-show="activeTab === 'assinatura'">
          <UserSubscriptionInfo
            :subscriptionConfig="item?.subscriptionConfig"
          />

          <UserSubscriptionHistory
            :transactions="subscriptionTransactions"
            :loading="loadingSubscriptions"
          />
        </div>

        <div v-show="activeTab === 'profissional'">
          <LoadingContainer v-if="loadingProfessional" />
          <ProfessionalInfo
            :professional="professional"
            @onUpdated="onProfessionalUpdated"
          />
          <UserCredentialList :crms="item?.crms || []" />
        </div>

        <div v-show="activeTab === 'prontuario'">
          <div class="card">
            <div class="card-header">
              <h2 class="text-header mb-0">Prontuário</h2>
            </div>

            <div
              class="table-responsive"
              v-if="item.medicalRecords && item.medicalRecords.length"
            >
              <table class="table table-sm table-nowrap card-table table-hover">
                <TableHead :columns="columns" />
                <tbody class="list">
                  <tr
                    v-for="(item, index) in item.medicalRecords"
                    v-bind:key="'tr-' + index"
                  >
                    <td>{{ item.patient?.name }}</td>
                    <td>{{ item.digital ? "Sim" : "Não" }}</td>
                    <td>
                      <time>{{
                        $moment(item.created_at).format("DD/MM/YYYY")
                      }}</time>
                    </td>
                    <td
                      v-if="item.pdf_url"
                      class="text-end cursor-pointer"
                      @click="openPDF(item)"
                    >
                      <i
                        class="fa-solid fa-lg fa-file-pdf text-primary"
                        data-bs-toggle="tooltip"
                        title="Ver prontuário"
                      ></i>
                    </td>
                    <td v-else></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <EmptyState
              v-else
              icon="fa-solid fa-clipboard-user"
              title="Nenhum prontuário encontrado"
              :noMsg="true"
            />
          </div>
        </div>

        <div
          v-if="item.type == 'professional'"
          v-show="activeTab === 'receitas'"
        >
          <div class="card">
            <div class="card-header">
              <h2 class="text-header mb-0">Receita</h2>
            </div>

            <div
              class="table-responsive"
              v-if="item?.prescriptions && item?.prescriptions.length"
            >
              <table class="table table-sm table-nowrap card-table table-hover">
                <TableHead :columns="columns" />
                <tbody class="list">
                  <tr
                    v-for="(item, index) in item.prescriptions"
                    v-bind:key="'tr-' + index"
                  >
                    <td>{{ item.patient?.name }}</td>
                    <td>{{ item.digital ? "Sim" : "Não" }}</td>
                    <td>
                      <time>{{
                        $moment(item.created_at).format("DD/MM/YYYY")
                      }}</time>
                    </td>
                    <td
                      class="text-end cursor-pointer"
                      v-if="item.pdf_url"
                      @click="openPDF(item)"
                    >
                      <i
                        class="fa-solid fa-lg fa-file-pdf text-primary"
                        data-bs-toggle="tooltip"
                        title="Ver receita"
                      ></i>
                    </td>
                    <td v-else></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <EmptyState
              v-else
              icon="fa-solid
            fa-prescription-bottle-medical"
              title="Nenhuma receita encontrada"
              :noMsg="true"
            />
          </div>
        </div>
      </template>
    </Container>
  </div>
</template>
<script>
import UserDetailController from "./UserDetailController";
export default UserDetailController;
</script>
